module.exports = __webpack_public_path__ + "static/img/siege_engineer.9eb9220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/siege_engineer.png
// module id = YZuy
// module chunks = 0